import React from 'react';

// Custom headshot images for each AI employee (hosted on CDN)
const AGENT_IMAGES = {
  kathy: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/9rypvevj_Kathy%20-%20AI%20HR%20Generalist.jpg',
  sophie: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/pn48t36z_Sophie%20-%20AI%20Talent%20Sourcer.jpg',
  john: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/l4ykrdlq_John%20-%20AI%20Compliance%20Analyst.jpg',
  omar: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/zaowty7w_Omar%20-%20AI%20Payroll%20Cordinator.jpg',
  priya: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/qq4krqe2_Priya%20-%20AI%20Benefits%20Administrator.jpg',
  mario: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/t2vrcdjh_Mario%20-%20AI%20Employee%20Relations%20Partner.jpg',
  linda: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/fs3exv1r_Linda%20-%20ALearning%20and%20Development%20Lead.jpg',
  alex: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/tc2oxyt5_Alex%20-%20AI%20Perfromance%20Manager.jpg',
  felix: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/pvkidjjm_Felix%20-%20AI%20Scheduling%20Assistant.jpg',
  jasmine: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/jjt13hih_Jasmine%20-%20AI%20Diversity%20and%20Inclusion%20Specialist.jpg',
  megan: 'https://customer-assets.emergentagent.com/job_ai-employees-6/artifacts/fida13or_Megan%20-%20AI%20Training%20Content%20Creator.jpg',
};

// Agent color mapping for fallback SVGs
const AGENT_COLORS = {
  kathy: '#2E7D32', sophie: '#7B1FA2', john: '#1565C0', omar: '#E65100',
  priya: '#00897B', mario: '#D32F2F', linda: '#E65100', alex: '#283593',
  felix: '#0097A7', jasmine: '#AD1457', megan: '#4527A0',
};

const AGENT_INITIALS = {
  kathy: 'K', sophie: 'S', john: 'J', omar: 'O',
  priya: 'P', mario: 'M', linda: 'L', alex: 'A',
  felix: 'F', jasmine: 'Ja', megan: 'Me',
};

export function AgentAvatar({ agentType, size = 56 }) {
  const imageUrl = AGENT_IMAGES[agentType];
  const color = AGENT_COLORS[agentType] || '#64748b';

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={agentType}
        style={{
          width: size,
          height: size,
          borderRadius: size > 50 ? 16 : 12,
          objectFit: 'cover',
          border: `2px solid ${color}20`,
        }}
        loading="lazy"
      />
    );
  }

  // SVG fallback for agents without custom images
  const initial = AGENT_INITIALS[agentType] || '?';
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <rect width="100" height="100" rx="20" fill={color} />
      <circle cx="50" cy="38" r="20" fill="#FFDBB4" />
      <path d="M32 34 Q38 14 50 12 Q62 14 68 34" fill={color} opacity="0.7" />
      <circle cx="43" cy="36" r="2.5" fill="#1e293b" />
      <circle cx="57" cy="36" r="2.5" fill="#1e293b" />
      <path d="M45 46 Q50 50 55 46" stroke="#c0392b" strokeWidth="2" fill="none" strokeLinecap="round" />
      <path d="M30 55 L50 70 L70 55 L70 92 Q70 96 66 96 L34 96 Q30 96 30 92Z" fill={color} />
      <text x="50" y="82" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">{initial}</text>
    </svg>
  );
}

export default AgentAvatar;
